module.exports = {
      id: "icon-audio-whatsapp-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-audio-whatsapp",
      toString: function () {
        return this.url;
      }
    }